<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><em>To my adorable pup, Winnie Cooper.<br/>May your mood be ever improved from eating<br/>all the scraps off the kitchen floor during the creation of this book.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?67b7e5a6